import fieldMixin from '@maison/mixins/fieldMixin';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';

export default {
  components: {
    CheckboxField,
  },

  mixins: [fieldMixin],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    shouldDisplayStayInTouch: {
      type: Boolean,
      default: false,
    },
    privacyLink: {
      type: String,
      default: '',
    },
  },

  computed: {
    stayInTouch() {
      return this.$t('Form.stayInTouch', {
        privacyLink: `<a target='_blank' href='${this.privacyLink}'>${this.$t('Form.privacy')}</a>`,
      });
    },
  },
};
